


var url = window.location.hostname;

let mainUrl =  'http://localhost:3001'
if(url.includes("localhost")){
	mainUrl =  'http://localhost:3001'
}
else{
	var dz = url.split('.')[0];
	if(dz){
		mainUrl = `https://${dz}.main-api.dizio.app`;
	}
}

const func = {};
func.getMainApiUrl = () => {
    return mainUrl;
}
export default func;